import { render, staticRenderFns } from "./StockTable_custom.vue?vue&type=template&id=52a7561b&"
import script from "./StockTable_custom.vue?vue&type=script&lang=js&"
export * from "./StockTable_custom.vue?vue&type=script&lang=js&"
import style0 from "./StockTable_custom.vue?vue&type=style&index=0&id=52a7561b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports